import { type Fetch } from '../types'

const allController: Record<string, AbortController> = {}

export function configAutoCancel(nextFetch: Fetch): Fetch {

  return async function (input: RequestInfo | URL, init?: RequestInit) {
    if (!init?.autoCancel)
      return await nextFetch(input, init)

    const request = input instanceof Request ? input : new Request(input)
    if (init.method ?? request.method !== 'GET')
      throw new Error('Auto cancel only supports GET requests')

    const controllerKey = (() => {
      const url = new URL(request.url)
      return `${url.origin}${url.pathname}`
    })()

    if (allController[controllerKey] && !allController[controllerKey].signal.aborted) {
      allController[controllerKey].abort()
    }

    const controller = allController[controllerKey] = new AbortController()
    try {
      return await nextFetch(input, { ...init, signal: controller.signal })
    } finally {
      if (controller === allController[controllerKey])
        delete allController[controllerKey]
    }
  }
}
